import './_product-card-swatch.scss';

export default () => {};
